<template>
  <default-layout>
     <v-layout wrap>

         <v-flex xs12 class="pt-5">
            <v-card class="elevation-12">
              <v-toolbar dark color="blue darken-1">
                <v-toolbar-title>Edit Phone Number</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-container grid-list-md mx-1>
                    <v-layout wrap>
                      <v-flex xs12 sm6>
                        <v-autocomplete
                          v-validate="'required'"
                          :error-messages="errors.collect('countryCode')"
                          data-vv-name="countryCode"
                          :items="countryCodes"
                          v-model="user.countryCode"
                          label="Country Code"
                          single-line
                          item-text="text"
                          item-value="text"
                          required
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                          v-validate="'required'"
                          :error-messages="errors.collect('phone')"
                          data-vv-name="phone"
                          v-model="user.phone"
                          label="Phone No."
                          type="text"
                        ></v-text-field>
                        <span style="color: red">{{phone_msg}}</span>
                      </v-flex>
                      <v-flex xs12>
                        <v-btn color="blue darken-1" @click="save" :loading="loading" dark>Submit</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
            </v-card>
         </v-flex>
     </v-layout>
     <app-snackbar ref="mySnackbar"></app-snackbar>
  </default-layout>
</template>
<script>
import { mapGetters } from "vuex";
import { countryCodes } from "@/common/methods.js";
export default {
  name: 'EditPasswordPage',
  computed: {
    ...mapGetters(["user"])
  },
  data () {
    return {
      err_msg: null,
      loading: false,
      countryCodes: countryCodes(),
      phone_msg: null
    };
  },
  methods: {
    save() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          if (this.user.phone == null) {
            this.$refs.mySnackbar.show("Phone No. is required.", "red");
          } else if(this.user.phone.startsWith('0')) {
            this.phone_msg = "If your Country Code is correct, do not start with ‘0’";
          } else if(!/^[0-9]+$/.test(this.user.phone)) {
            this.phone_msg = "Phone no should be Numerals only...";
          } else {
            this.phone_msg = null;
            const data = {
              phone: this.user.phone,
              countryCode: this.user.countryCode
            };

            const self = this;
            self.loading = true;
            const res = this.$store
              .dispatch("post", { url: "/user/changephone/" + self.user._id, data })
              .then(res => {
                self.loading = false;
                if (res.state == false) {
                  this.$refs.mySnackbar.show(res.msg, "red");
                } else {
                  self.$store.commit("setUser", self.user);
                  this.$refs.mySnackbar.show("Phone no. updated successfully.", "green");
                }
              })
              .finally(() => {
                // stuffs happens here
              });
          }
        }
      });
      //end of validation
    }
  }
}
</script>
